export const MAGAZINE_ARTICLE_DATA_PATH = '/json-data/magazine-articles.json';
